<template>
  <div style="background:#f7f7f7;padding-top:20px;">
    <div class="plate-one main-width">
      <div class="row-framework">
        <div class="match-sub-title">{{$t('组织机构')}}</div>
        <div class="content">
          <a-tabs v-if="info.company !== null" type="card" :default-active-key="0">
            <a-tab-pane
              size="small"
              :key="index"
              :tab="item.name"
              v-for="(item,index) in info.company"
            >
              <div class="s-content">
                <div v-for="(text,i) in item.data" :key="i" style="width:100%;">{{text}}</div>
              </div>
            </a-tab-pane>
          </a-tabs>
          <a-empty style="padding-top:30px;" v-else/>
        </div>
      </div>
      <div class="row-apply">
        <div class="match-sub-title">{{$t('报名时间')}}</div>
        <div class="content">
          <div class="time">
            <label
              class="count-down"
              :style="{background: '#b80000'}"
            >
              <span v-if="countdown.min > 0 || countdown.second > 0">
                还剩
                <span>{{countdown.day}}</span>天
                <span>{{countdown.hour}}</span>时
                <span>{{countdown.min}}</span>分
                <span>{{countdown.second}}</span>秒
              </span>
              <span v-else>{{$t('报名已截止')}}</span>
            </label>
            <div class="time-content">
              <p>{{$t('报名时间')}}：{{info.joinStartTime?info.joinStartTime.substring(0,10):'0'}}至{{info.joinOverTime?info.joinOverTime.substring(0,10):'0'}}</p>
              <p>{{$t('比赛时间')}}：{{info.beginTime?info.beginTime.substring(0,10):'0'}}至{{info.endTime?info.endTime.substring(0,10):0}}</p>
              <p>{{$t('联系方式')}}：{{info.mobile}}</p>
            </div>
          </div>
          <div class="qr-code">
            <label class="code-title">{{$t('扫码进入小程序')}}</label>
            <div class="img-code">
              <img v-if="miniCode !== null" :src="miniCode">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store'
export default {
  name: 'MatchCompany',
  components: {
  },
  created () {
    this.init()
  },
  mounted () {
  },
  data () {
    return {
      info: {},
      matchId: this.$route.query.matchId,
      programId: this.$route.query.programId,
      countdown: {
        day: 0,
        hour: 0,
        min: 0,
        second: 0
      },
      miniCode: null
    }
  },
  methods: {
    init () {
      if (store.getters['match/matchInfo'] === null) {
        this.findData()
      } else {
        if (store.getters['match/matchInfo'].matchId !== this.matchId) {
          this.findData()
        } else {
          this.info = store.getters['match/matchInfo']
          setInterval(this.countdownfun, 1000)
        }
      }
      this.getMiniCode()
    },
    getMiniCode () {
      let miniCode = store.getters['match/miniCode']
      if (miniCode === null || !miniCode[this.matchId]) {
        if (miniCode === null) {
          miniCode = {}
        }
        // 最多保留三个缓存小程序码，节约缓存空间
        if (Object.keys(miniCode).length >= 3) {
          miniCode = {}
        }
        this.$api.match.getMiniCode({scene: this.matchId + '!' + this.programId, page: 'packages/match/pages/detail/home'}).then(res => {
          if (res.status === 0) {
            miniCode[this.matchId] = res.data
            this.miniCode = res.data
            store.commit('match/MATCH_CHANGE_MINI_CODE', miniCode)
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.miniCode = miniCode[this.matchId]
      }
    },
    findData () {
      this.$api.match.websiteMatchDetail({matchId: this.matchId}).then(res => {
        if (res.status === 0) {
          this.info = res.data
          this.info.matchId = this.matchId
          this.info.company = JSON.parse(this.info.company)
          setInterval(this.countdownfun, 1000)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    countdownfun () {
      let date = new Date()
      let now = date.getTime()
      let endDate = new Date(this.info.joinOverTime.replace(/-/g, '/'))
      let end = endDate.getTime()
      let leftTime = end - now
      if (leftTime >= 0) {
        this.countdown.day = Math.floor(leftTime / 1000 / 60 / 60 / 24)
        let h = Math.floor((leftTime / 1000 / 60 / 60) % 24)
        this.countdown.hour = h < 10 ? '0' + h : h
        let m = Math.floor((leftTime / 1000 / 60) % 60)
        this.countdown.min = m < 10 ? '0' + m : m
        let s = Math.floor((leftTime / 1000) % 60)
        this.countdown.second = s < 10 ? '0' + s : s
      } else {
        this.countdown.day = 0
        this.countdown.hour = '00'
        this.countdown.min = '00'
        this.countdown.second = '00'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.main-width {
  width:1200px;
  margin-left:auto;
  margin-right:auto;
}
.match-sub-title {
  font-size: 18px;
  font-weight: bold;
  color: #232323;
  line-height: 40px;
}
.plate-one {
  display: flex;
  flex-direction: row;
  .row-framework,
  .row-apply {
    flex: 1;
    .content {
      height: 200px;
    }
  }
  .row-framework {
    margin-right: 20px;
    .content {
      background-color: #fff;
    }
    .s-content {
      padding: 5px 20px;
      height: 135px;
      overflow-y: auto;
    }
  }
  .row-apply {
    margin-left: 20px;
    .content {
      display: flex;
      flex-direction: row;
    }
    .time {
      flex: 2;
      margin-right: 40px;
      background-color: #fff;
      .count-down {
        text-align: center;
        color: #fff;
        display: block;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
      }
      span {
        font-size: 16px;
        font-weight: bold;
      }
      .time-content {
        color: #000;
        padding: 0 15px;
        p {
          display: block;
          height: 30px;
          line-height: 40px;
        }
      }
    }
    .qr-code {
      background-color: #fff;
      flex: 1;
      display: flex;
      flex-direction: column;
      .code-title {
        background-color: #434343;
        height: 40px;
        line-height: 40px;
        color: #fff;
        text-align: center;
      }
      .img-code {
        height: 160px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 120px;
          height: 120px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/MatchCompany.vue